import React, {useContext, useEffect, useState} from 'react';
import '../styles/Main.css'
import NavPanel from '../components/NavPanel'
import {Link} from "react-router-dom";
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import HistoryContainer from "../components/HistoryContainer";
import {WsTriggers} from "../WebsocketTriggers";
import {taskDeleteAPI, taskGetAPI, taskPostAPI, taskPutAPI} from "../http/taskAPI";
import {addMessageIntoHtml, formatDateString} from "../utils/utilsFunctions";
import {companyGetAPI} from "../http/companyAPI";
import {URLS} from "../utils/urls";
import { calculationGetAPI, calculationGetByIdAPI, calculationSearchAPI, calculationUpdateStatusAPI } from "../http/calculationAPI";
import { payeesGetApi } from "../http/payeeAPI";
import { deliveryNoteGetAPI } from "../http/deliveryNoteAPI";
import toastStore from "../store/ToastStore";
import Popup from "../components/Popup";
import CalculationTable, {CalcConfig, normalizeCalcConfig, configOfCalcTable} from "../components/CalculationTable";
import {REACT_APP_API_URL} from "../config";
import {setCookie} from "../utils/cookies";
import $ from 'jquery';

const paidIco = require('../assets/icons/main/paidIco.png');
const notPaidIco = require('../assets/icons/main/notPaidIco.png');

const saveIco = require('../assets/icons/selectedComp/saveIco.png');
const saveUnactiveIco = require('../assets/icons/selectedComp/saveUnactiveIco.png');
const editIco = require('../assets/icons/selectedComp/editIco.png');
const editUnactiveIco = require('../assets/icons/selectedComp/editUnactiveIco.png');
const delIco = require('../assets/icons/selectedComp/deleteIco.png');
const backIco = require('../assets/icons/selectedComp/backIco.png');


type TaskOptionsType = 'taskAll' | 'taskMine' | 'taskNew';

type UsersType = { [key: number]: string };
type CompaniesType = Array<[ number, string ]>;
type TaskDataObjectType = {
    id: number,
    context: string,
    status: boolean | null,
    createdAt: string,
    updatedAt: string,
    companyTaskId: number | null,
    doingTaskById: number | null,
    createdTaskById: number | null,
    company: { id: number, name: string } | null,
    doingBy: { id: number, username: string } | null,
    createdBy: { id: number, username: string } | null,
}

type CalculationDataType = {
    id: number,
    status: boolean | null,
    invoice: string | null,
    calculation: {
        tableData: {
            [key: number]: {
                a: string,
                b: string,
                c: string,
                d: string,
                e: string,
                f: string,
                g: string,
                h: string,
                i: string,
                j: string,
                k: string,
                l: string,
            }
        },
        tableResult: {
            expensesTax: string,
            incomeTax: string,
            profit: string,
        }
    },
    createdAt: string,
    updatedAt: string,
    closedAt: string | null,
    companyId: number,
    pdfFile: string | null,
    payeeId: number | null,
    payee?: { id: number, name: string } | null,
    company: {
        id: number,
        name: string,
        curatorId: number | null,
    },
    createdBy: { id: number, username: string },
    closedBy: { id: number, username: string }
}

type PayeeLiteType = { id: number, name: string };

// One hit from calculationSearchAPI — just enough to point the calendar at
// the right day and flash the matching row.
type CalcSearchMatchType = {
    id: number,
    invoice: number | null,
    status: boolean | null,
    closedAt: string | null,
    createdAt: string,
    companyId: number,
    company: { id: number, name: string, curatorId: number | null } | null,
    payee: { id: number, name: string } | null,
}

// Full single-calc payload from calculationGetByIdAPI, used to open the
// "данные о счёте" popup from the calendar — richer than CalculationDataType
// (adds the resolved schema/rates sources and the raw row data).
type CalcDetailType = {
    id: number,
    status: boolean | null,
    invoice: string | null,
    pdfFile: string | null,
    calculation: { tableData: { [key: number]: { [key: string]: string } } },
    createdAt: string,
    closedAt: string | null,
    companyId: number,
    company: { id: number, name: string } | null,
    payee?: { id: number, name: string, calcConfig?: any } | null,
    payeeSnapshot?: { calcConfig?: any } | null,
    calcTable?: { id: number, name: string, config: any, hiddenColumns?: string[] | null } | null,
    createdBy: { id: number, username: string } | null,
    closedBy: { id: number, username: string } | null,
}


const TasksView = (params: {
    tasksData: Array<TaskDataObjectType> | null,
    tasksType: 'all' | 'my',
    permissions: Set<string>,
    userId: string | number,
    editableButton: null | number,
    setEditableButton: React.Dispatch<React.SetStateAction<number | null>>
    usersData: UsersType,
    companiesData: CompaniesType
}) => {
    const tasksData = params.tasksData;
    const perms = params.permissions;

    let tasksLength = 0;
    if (tasksData) {
        tasksLength = tasksData.length;
    }

    const usersData = params.usersData;
    const companiesData = params.companiesData;

    // @ts-ignore
    return (
        <div className="main__data-body main__task-body contentWindow__body">
            {
                tasksData ?
                        tasksLength === 0 ?
                            <div className='main__tasks-task-wrapper'>
                                <div className='main__tasks-empty-task-container'>
                                    <span>На сегодня задач нет</span>
                                </div>
                            </div>
                        :
                        tasksData.map((td) =>
                            <div key={ `${params.tasksType}Task-${td.id}` } className='main__tasks-task-wrapper'>
                                <div className="main__tasks-task-container">
                                    <div className='main__tasks-task-header'>
                                        <div className='main__tasks-task-creatorName-container'>
                                            <span>
                                                {td.createdBy ? td.createdBy.username : ''}
                                            </span>
                                        </div>
                                        <div className='main__tasks-task-time-container'>
                                            <span>
                                                {formatDateString(td.createdAt)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='main__tasks-task-body'>
                                        <div className='main__task-content-container'>
                                            {
                                                    params.editableButton ? 
                                                        params.editableButton === td.id ?
                                                                <div className='main__task-select-wrapp'>
                                                                    <select defaultValue={td.company ? td.company.id : "null"} name="company" id="taskCompany" className='main__task-select-edit'>
                                                                    <option value="null">Не задан</option>
                                                                {
                                                                    companiesData.map((el) =>
                                                                            <option key={ `comp-${el[0]}` } value={ `${el[0]}` }>{el[1]}</option>
                                                                    ) 
                                                                }
                                                                    </select>
                                                                </div>
                                                            :
                                                            td.company ?
                                                                <Link to={ URLS.COMPANY_URL.replace(':id', `${td.company.id}`) }
                                                                    className='main__tasks-task-companyRef'>{td.company.name}
                                                                </Link>
                                                                :
                                                                null
                                                        :
                                                        td.company ?
                                                            <Link to={ URLS.COMPANY_URL.replace(':id', `${td.company.id}`) }
                                                                className='main__tasks-task-companyRef'>{td.company.name}
                                                            </Link>
                                                            :
                                                            null   
                                            }

                                            <div className='main__tasks-task-context-container'>
                                                {
                                                    params.editableButton ? 
                                                        params.editableButton === td.id ?
                                                            <textarea name={`taskContext-${td.id}`} id={`taskContext`} className="main__tasks-textarea"
                                                                onInput={(el: any) => {
                                                                    const textarea = el.target
                                                                    textarea.style.height = 'auto';
                                                                    textarea.style.height = textarea.scrollHeight + 'px';
                                                                    
                                                                }}
                                                            defaultValue={td.context.replaceAll('<br>', '\n')}>
                                                                
                                                            </textarea>
                                                            :
                                                            <span className='main__tasks-task-context'
                                                                dangerouslySetInnerHTML={{__html: td.context}}>
                                                            </span>
                                                        :
                                                        <span className='main__tasks-task-context'
                                                            dangerouslySetInnerHTML={{__html: td.context}}>
                                                        </span>
                                                }
                                            </div>
                                        </div>
                                        {
                                            params.tasksType === 'all' ?
                                                <div className='main__task-edit-container'>
                                                    {
                                                        perms.has('tasks.delete') ? 
                                                        params.editableButton ? 
                                                            params.editableButton === td.id ?
                                                                <div className="main__task-edit-btn-configs">
                                                                    <button className='main__task-save-btn' onClick={() => { 
                                                                            params.setEditableButton(null);
                                                                            const taskCompany: any = document.getElementById('taskCompany');
                                                                            const taskContext: any = document.getElementById('taskContext');
                                                                            const taskUser: any = document.getElementById('taskUser');
                                                                            if (taskCompany && taskContext && taskUser) {                                                                                
                                                                                const taskData = {
                                                                                    "user": taskUser.value,
                                                                                    "company": taskCompany.value,
                                                                                    "taskContext": taskContext.value,
                                                                                }
                                                                                taskPutAPI({ id: td.id, taskData: taskData })
                                                                                    .then((response) => {})
                                                                                    .catch((err) => {
                                                                                        console.log(err);
                                                                                    })
                                                                            }

                                                                        }}>
                                                                        <img className='main__task-edit-ico' src={saveIco} alt="edit" />
                                                                    </button>
                                                                    <button className='main__task-back-btn' onClick={() => { 
                                                                            params.setEditableButton(null);
                                                                        }}>
                                                                        <img className='main__task-edit-ico' src={backIco} alt="edit" />
                                                                    </button>
                                                                </div>
                                                            
                                                                :

                                                                <button className='main__task-edit-btn-unactive'>
                                                                    <img className='main__task-edit-ico' src={editUnactiveIco} alt="edit" />
                                                                </button>
                                                            
                                                            :
                                                            <button className='main__task-edit-btn' onClick={() => { 
                                                                    params.setEditableButton(td.id);
                                                                    setTimeout(() => {
                                                                        const textarea = document.getElementById('taskContext');
                                                                        if (textarea) {
                                                                            textarea.style.height = 'auto';
                                                                            textarea.style.height = textarea.scrollHeight + 'px';
                                                                        }
                                                                    }, 10)
                                                                }}>
                                                                <img className='main__task-edit-ico' src={editIco} alt="edit" />
                                                            </button>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                    
                                                :
                                                null
                                        }
                                    </div>
                                    {
                                        params.tasksType === 'all' ?
                                            <div className='main__tasks-task-footer'>
                                                {
                                                    params.editableButton ?
                                                        params.editableButton === td.id ?
                                                            <div className='main__task-select-wrapp-user'>
                                                                <select defaultValue={td.doingBy ? td.doingBy.id : "null"} name="user" id="taskUser" className='main__task-select-edit-user'>
                                                                    <option value="null">Не задан</option>
                                                                    {
                                                                        Object.entries(usersData).map((el) =>
                                                                            <option key={`user-${el[0]}`} value={`${el[0]}`}>{el[1]}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                            :
                                                            td.doingBy ?
                                                                <span className='main__tasks-task-doingBy-name'>
                                                                    Выполняет: {td.doingBy.username}
                                                                </span>
                                                                :
                                                                <button
                                                                    className='nav__button main__tasks-task-btn main__tasks-task-takeTask'
                                                                    onClick={() => {
                                                                    taskPutAPI({id: td.id, query: 'take', user: params.userId})
                                                                            .then((response) => { })
                                                                            .catch((err) => {
                                                                                console.log(err)
                                                                            })
                                                                    }}
                                                                >Взять задачу</button>                                                
                                                        :
                                                        td.doingBy ?
                                                            <span className='main__tasks-task-doingBy-name'>
                                                                Выполняет: {td.doingBy.username}
                                                            </span>
                                                            :
                                                            <button
                                                                className='nav__button main__tasks-task-btn main__tasks-task-takeTask'
                                                                onClick={() => {
                                                                taskPutAPI({id: td.id, query: 'take', user: params.userId})
                                                                        .then((response) => { })
                                                                        .catch((err) => {
                                                                            console.log(err)
                                                                        })
                                                                }}
                                                            >Взять задачу</button>
                                                }
                                                {
                                                    perms.has('tasks.delete') ?
                                                        <button
                                                            className='nav__button main__tasks-task-btn main__tasks-task-delTask'
                                                            onClick={() => {
                                                                taskDeleteAPI(td.id)
                                                                    .then((response) => {})
                                                                    .catch((err) => {
                                                                        console.log(err) })
                                                            }}
                                                        >Удалить</button>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                            :
                                            <div className='main__tasks-task-footer'>
                                                <button className='nav__button main__tasks-task-btn main__tasks-task-takeTask'
                                                    onClick={() => {
                                                                taskPutAPI({id: td.id, query: 'done', user: params.userId})
                                                                    .then((response) => {})
                                                                    .catch((err) => {
                                                                        console.log(err) })
                                                    }}
                                                >Выполнено</button>
                                                <button className='nav__button main__tasks-task-btn main__tasks-task-cancelTask'
                                                    onClick={() => {
                                                                taskPutAPI({id: td.id, query: 'deny', user: params.userId})
                                                                    .then((response) => {})
                                                                    .catch((err) => {
                                                                        console.log(err) })
                                                    }}
                                                >Отказаться</button>
                                            </div>
                                    }
                                </div>
                            </div>
                        )
                    :
                    null
            }
        </div>
    )
};


const TasksNew = (params: { usersData: UsersType, companiesData: CompaniesType, createdBy: number }) => {
    const usersData = params.usersData;
    const companiesData = params.companiesData;

    const handleSaveTask = (e: any) => {
        const { user, company, taskContext } = e.target;

        if (taskContext.value.length === 0 || taskContext.value.replaceAll(' ', '').length === 0) {
            addMessageIntoHtml({ elementId: 'taskResMsg', msgColor: "red", message: 'Текст не должен быть пустым', hideElemInSec: 2 })
        } else {
            const reqData = {
                context: taskContext.value.replaceAll('\n', '<br>'),
                user: user.value === 'null' ? null : user.value,
                company: company.value === 'null' ? null : company.value,
                createdBy: params.createdBy,
            }

            taskPostAPI(reqData)
                .then((response) => {
                    if (response.status === 200) {
                        addMessageIntoHtml({ elementId: 'taskResMsg', msgColor: "green", message: 'Задача успешно создана', hideElemInSec: 3 })
                    } else {
                        addMessageIntoHtml({ elementId: 'taskResMsg', msgColor: "red", message: 'Ошибка', hideElemInSec: 3 })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }

    }

    return (
        <div className="main__data-body main__task-body contentWindow__body">
            <form className="main__task-textarea-container" onSubmit={(e: any) => {
                e.preventDefault();
                handleSaveTask(e);}}>
                <textarea className='input main__task-textarea' name='taskContext'></textarea>
                <div className='main__task-options-container'>
                    <div className='main__task-btn-save-wrapper'>
                        <button className='nav__button btn-primary main__task-btn-save' type='submit'>Сохранить</button>
                    </div>
                    <div className='main__task-select-wrapper'>
                        <span>Предприятие</span>
                        <select name="company" id="taskCompany" className='main__task-select'>
                            <option value="null">Не задан</option>
                            {
                                companiesData.map((el) =>
                                    <option key={ `comp-${el[0]}` } value={ `${el[0]}` }>{el[1]}</option>
                                )
                            }
                        </select>
                    </div>
                    <div className='main__task-select-wrapper'>
                        <span>Пользователь</span>
                        <select name="user" id="taskUser" className='main__task-select'>
                            <option value="null">Не задан</option>
                            {
                                Object.entries(usersData).map((el) =>
                                    <option key={ `user-${el[0]}` } value={ `${el[0]}` }>{el[1]}</option>
                                )
                            }
                        </select>
                    </div>
                </div>
            </form>
            <div className='task__response-msg'>
                <span id='taskResMsg'></span>
            </div>
        </div>
    )
}


const Main = observer(() => {
    const { user, ws } = useContext (Context);

    const [taskOption, setTaskOption] = useState<TaskOptionsType>('taskAll');
    const [taskBodyJSX, setTaskBodyJSX] = useState<JSX.Element>(<></>);

    const [perms, setPerms] = useState<Set<string>>(new Set());

    const [users, setUsers] = useState<UsersType>({});
    const [companies, setCompanies] = useState<CompaniesType>([]);

    const [allTasks, setAllTasks] = useState<Array<TaskDataObjectType> | null>(null);
    const [myTasks, setMyTasks] = useState<Array<TaskDataObjectType> | null>(null);

    const [allCalculations, setAllCalculations] = useState<Array<CalculationDataType>>([]);
    const [calcCuratorFilter, setCalcCuratorFilter] = useState<string>('');

    // A calc marked paid/notPaid drops out of the (pending-only) list on the
    // next WS-triggered refetch — often before a fade could even be seen. To
    // let the <tr> actually animate out, we keep a snapshot of it around for
    // FADE_MS after the click and render from that snapshot too.
    const [fadingCalcIds, setFadingCalcIds] = useState<Set<number>>(new Set());
    const [fadedCalcCache, setFadedCalcCache] = useState<{ [id: number]: CalculationDataType }>({});
    const FADE_MS = 350;

    const startCalcFadeOut = (ac: CalculationDataType) => {
        setFadedCalcCache((prev) => ({ ...prev, [ac.id]: ac }));
        setFadingCalcIds((prev) => new Set(prev).add(ac.id));
        setTimeout(() => {
            setFadingCalcIds((prev) => { const next = new Set(prev); next.delete(ac.id); return next; });
            setFadedCalcCache((prev) => { const next = { ...prev }; delete next[ac.id]; return next; });
        }, FADE_MS);
    };

    // Undo an optimistic fade when the status update actually failed.
    const cancelCalcFadeOut = (id: number) => {
        setFadingCalcIds((prev) => { const next = new Set(prev); next.delete(id); return next; });
        setFadedCalcCache((prev) => { const next = { ...prev }; delete next[id]; return next; });
    };

    const [editableButton, setEditableButton] = useState<number | null>(null);

    // Calendar view of paid invoices — fetched lazily, only
    // once the calendar is opened, and re-fetched on WS CALC triggers while
    // it stays open.
    const [isCalcCalendarOpen, setIsCalcCalendarOpen] = useState<boolean>(false);
    const [closedCalculations, setClosedCalculations] = useState<Array<CalculationDataType> | null>(null);
    const [calendarMonth, setCalendarMonth] = useState<Date>(() => new Date());
    const [selectedCalendarDateKey, setSelectedCalendarDateKey] = useState<string | null>(null);

    // "Активные счета" header search: find a closed invoice by its number
    // (optionally scoped to a payee), then jump the calendar to its closing
    // day, flash that row and keep it outlined.
    const [payees, setPayees] = useState<Array<PayeeLiteType>>([]);
    const [calcSearchInvoice, setCalcSearchInvoice] = useState<string>('');
    const [calcSearchPayee, setCalcSearchPayee] = useState<string>('');
    const [calcSearching, setCalcSearching] = useState<boolean>(false);
    const [highlightCalcId, setHighlightCalcId] = useState<number | null>(null);
    const [flashCalcId, setFlashCalcId] = useState<number | null>(null);

    const requestClosedCalculations = () => {
        calculationGetAPI('all', 'calcPaid')
            .then((response) => {
                if (response.data) {
                    const closed: Array<CalculationDataType> = response.data.filter(
                        (c: CalculationDataType) => c.closedAt
                    );
                    setClosedCalculations(closed);
                }
            })
            .catch((err) => { console.log(err) });
    };

    const requestPayees = () => {
        payeesGetApi()
            .then((response) => {
                if (Array.isArray(response.data)) {
                    const list: Array<PayeeLiteType> = response.data.map((p: any) => ({ id: p.id, name: p.name }));
                    setPayees(list);
                    // No "all" option in the search select — default to the first payee.
                    setCalcSearchPayee((prev) => prev || (list[0] ? `${list[0].id}` : ''));
                }
            })
            .catch((err) => { console.log(err) });
    };

    // Flash the found row orange (fades back via CSS animation) and keep the
    // row outlined until the next search replaces (or clears) it.
    // Clearing the flash first re-arms the animation even when the same row
    // is searched for twice in a row.
    const highlightCalendarRow = (calcId: number) => {
        setHighlightCalcId(calcId);
        setFlashCalcId(null);
        window.setTimeout(() => {
            setFlashCalcId(calcId);
            window.setTimeout(() => {
                document.getElementById(`calcCalRow-${calcId}`)
                    ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }, 80);
        }, 30);
    };

    const handleCalcSearch = (e: React.FormEvent) => {
        e.preventDefault();
        const invoice = calcSearchInvoice.trim();
        if (!invoice) return;

        setCalcSearching(true);
        calculationSearchAPI(invoice, calcSearchPayee)
            .then((response: any) => {
                // The calendar shows paid invoices only, so skip notPaid hits.
                const matches: Array<CalcSearchMatchType> = (Array.isArray(response?.data) ? response.data : [])
                    .filter((m: CalcSearchMatchType) => m.status === true);
                if (matches.length === 0 || !matches[0].closedAt) {
                    setHighlightCalcId(null);
                    toastStore.push(`Счёт №${invoice} среди оплаченных не найден`, 'error');
                    return;
                }

                const match = matches[0];
                const closed = new Date(match.closedAt as string);

                // Switch to the calendar view and (re)load its data.
                setIsCalcCalendarOpen(true);
                requestClosedCalculations();

                // The curator filter is shared with the calendar — widen it if
                // it would otherwise hide the hit.
                const curatorId = `${match.company?.curatorId}`;
                if (calcCuratorFilter !== '' && calcCuratorFilter !== 'all' && curatorId !== calcCuratorFilter) {
                    setCalcCuratorFilter('all');
                }

                setCalendarMonth(new Date(closed.getFullYear(), closed.getMonth(), 1));
                setSelectedCalendarDateKey(
                    `${closed.getFullYear()}-${String(closed.getMonth() + 1).padStart(2, '0')}-${String(closed.getDate()).padStart(2, '0')}`
                );
                highlightCalendarRow(match.id);

                if (matches.length > 1) {
                    toastStore.push(`Найдено счетов: ${matches.length}. Открыт самый последний.`, 'info');
                }
            })
            .catch((err) => { console.log(err) })
            .finally(() => { setCalcSearching(false); });
    };

    // Detail popup opened from a calendar invoice row — the calc's own data,
    // the calculation table, and its footer results.
    const [isCalcDetailOpen, setIsCalcDetailOpen] = useState<boolean>(false);
    const [calcDetail, setCalcDetail] = useState<CalcDetailType | null>(null);
    // PDF of the calc's видаткова накладна (not part of the calc response).
    const [calcDetailNotePdf, setCalcDetailNotePdf] = useState<string | null>(null);

    const openCalcDetail = (calcId: number) => {
        setCalcDetailNotePdf(null);
        deliveryNoteGetAPI(calcId).then((res: any) => {
            if (res?.status === 200) setCalcDetailNotePdf(res.data?.note?.pdfFile ?? null);
        });
        calculationGetByIdAPI(calcId)
            .then((response) => {
                if (response.data) {
                    setCalcDetail(response.data);
                    setIsCalcDetailOpen(true);
                }
            })
            .catch((err) => { console.log(err) });
    };

    const calcDetailConfig: CalcConfig = normalizeCalcConfig(
        configOfCalcTable(calcDetail?.calcTable)
        ?? calcDetail?.payeeSnapshot?.calcConfig
        ?? calcDetail?.payee?.calcConfig
        ?? null
    );


    useEffect(() => {
        const message = ws.getMsg;
        if (message === WsTriggers.TASK) {
            requestTasks();
            ws.setMessage(null);
        } else if (message === WsTriggers.CALC) {
            requestCalculations();
            if (isCalcCalendarOpen) requestClosedCalculations();
            ws.setMessage(null);
        }
    }, [ws.getMsg]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        requestUsersAndCompanies();
        requestCalculations();
        requestPayees();
    }, []);

    useEffect(() => {
        if (isCalcCalendarOpen && closedCalculations === null) {
            requestClosedCalculations();
        }
    }, [isCalcCalendarOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (user.getUser.id) {
            requestTasks();
            setCalcCuratorFilter(`${user.getUser.id}`);
        }
    }, [user.getUser.id]);

    useEffect(() => {
        
    }, [editableButton])

    const taskOptionToAction = {
        'taskAll': () => {
            setTaskBodyJSX(TasksView({ tasksData: allTasks, tasksType: 'all', permissions: perms, userId: user.getUser.id, editableButton: editableButton, setEditableButton: setEditableButton, companiesData: companies, usersData: users }));
        },
        'taskMine': () => {
            setTaskBodyJSX(TasksView({ tasksData: myTasks, tasksType: 'my', permissions: perms, userId: user.getUser.id, editableButton: editableButton, setEditableButton: setEditableButton, companiesData: companies, usersData: users }));
        },
        'taskNew': () => {
            setTaskBodyJSX(TasksNew({ usersData: users, companiesData: companies, createdBy: user.getUser.id }));
        },
    }


    useEffect(() => {
        setPerms(user.getPermissions.data_);
    }, [user.getPermissions]);

    useEffect(() => {
        taskOptionToAction[taskOption]();
    }, [allTasks, myTasks, editableButton]);

    useEffect(() => {
        taskOptionToAction[taskOption]();

        if (taskOption !== 'taskAll') {
            setEditableButton(null);
        }
    }, [taskOption]);


    const requestTasks = () => {
        taskGetAPI()
            .then((response) => {
                if (response.data) {
                    const currentUserId = user.getUser.id;
                    const newAllTasks: Array<TaskDataObjectType> = [];
                    const newMyTasks: Array<TaskDataObjectType> = [];

                    for (let t = 0; t < response.data.length; t++) {
                        const taskObj: TaskDataObjectType = response.data[t];
                        newAllTasks.push(taskObj);
                        if (taskObj.doingTaskById === currentUserId) {
                            newMyTasks.push(taskObj);
                        }
                    }
                    setAllTasks(newAllTasks);
                    setMyTasks(newMyTasks);
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const requestUsersAndCompanies = () => {
        companyGetAPI()
            .then((response) => {
                if (response.data) {
                    const resUsers: UsersType = response.data.users;
                    const resCompanies: Array<{ id: number, name: string }> = response.data.companies;

                    if (user.getUser.username !== 'superuser') {
                        delete resUsers[1]
                    }

                    setUsers(resUsers);
                    setCompanies(resCompanies.map((el) => [el.id, el.name]));
                }
            })
            .catch((err) => {
                console.log(err)
            });
    };

    const requestCalculations = () => {
        calculationGetAPI( 'all', 'calcPending')
            .then((response) => {
                if (response.data) {
                    setAllCalculations(response.data);
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }

    const visibleCalculationsBase = calcCuratorFilter === '' || calcCuratorFilter === 'all' ?
        allCalculations
        :
        allCalculations.filter((ac) => `${ac.company.curatorId}` === calcCuratorFilter);

    // Keep rendering a just-faded-out calc for FADE_MS even after it's gone
    // from allCalculations, so the disappearance animation has time to play.
    const stillFadingCalcs = Object.values(fadedCalcCache)
        .filter((ac) => !visibleCalculationsBase.some((v) => v.id === ac.id));
    const visibleCalculations = [...visibleCalculationsBase, ...stillFadingCalcs];

    const changeCalcStatus = (params: { calcId: number | string, status: 'paid' | 'notPaid' }) => {
        calculationUpdateStatusAPI(params.calcId, params.status, user.getUser.id)
            .then((response) => {
                if (!response.status) {
                    replaceCalcBtnWithLoading({ elId: params.calcId, action: 'show' });
                    cancelCalcFadeOut(Number(params.calcId));
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const replaceCalcBtnWithLoading = (params: { elId: number | string, action: 'hide' | 'show' }) => {
        const elId = params.elId;
        const action = params.action;

        const paidCalcBtn = $(`#paidCalcBtn-${elId}`);
        const notPaidCalcBtn = $(`#notPaidCalcBtn-${elId}`);

        if (action === 'hide') {
            paidCalcBtn.css({ 'display': 'none' });
            notPaidCalcBtn.css({ 'display': 'none' });
            $(`#paidCalcTd-${elId}`).append(`<div class="loader" id="paidCalcLoader-${elId}" style="margin: 0 auto"></div>`)
            $(`#notPaidCalcTd-${elId}`).append(`<div class="loader" id="notPaidCalcLoader-${elId}" style="margin: 0 auto"></div>`)
        } else {
            $(`paidCalcLoader-${elId}`).remove();
            $(`notPaidCalcLoader-${elId}`).remove();
            paidCalcBtn.css({ 'display': 'block' });
            notPaidCalcBtn.css({ 'display': 'block' });
        }

    }

    // ── Closed-invoices calendar ──────────────────────────────────────────
    // Same curator filter the "Активные счета" list/select already uses.
    // `company` can be null for a calc whose company was since deleted.
    const closedForCurator = (closedCalculations ?? []).filter((c) =>
        calcCuratorFilter === '' || calcCuratorFilter === 'all' || `${c.company?.curatorId}` === calcCuratorFilter
    );

    const dateKey = (iso: string): string => {
        const d = new Date(iso);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const closedByDateKey: { [key: string]: Array<CalculationDataType> } = {};
    closedForCurator.forEach((c) => {
        const key = dateKey(c.closedAt as string);
        (closedByDateKey[key] = closedByDateKey[key] || []).push(c);
    });

    const MONTH_NAMES = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    const WEEKDAY_NAMES = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

    const buildMonthGrid = (monthDate: Date): Array<Date | null> => {
        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const firstWeekday = (new Date(year, month, 1).getDay() + 6) % 7; // Mon=0..Sun=6
        const cells: Array<Date | null> = [];
        for (let i = 0; i < firstWeekday; i++) cells.push(null);
        for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));
        while (cells.length % 7 !== 0) cells.push(null);
        return cells;
    };

    const calendarGrid = buildMonthGrid(calendarMonth);
    const todayKey = dateKey(new Date().toISOString());

    const shiftCalendarMonth = (delta: number) => {
        setCalendarMonth((prev) => new Date(prev.getFullYear(), prev.getMonth() + delta, 1));
        setSelectedCalendarDateKey(null);
    };

    const openCalcCalendar = () => {
        setIsCalcCalendarOpen((prev) => !prev);
        setSelectedCalendarDateKey(null);
    };

    const selectedDateCalcs = selectedCalendarDateKey ? (closedByDateKey[selectedCalendarDateKey] || []) : [];
    const CALC_STATUS_LABEL: { [key: string]: { text: string, cls: string } } = {
        'true': { text: 'Оплачен', cls: 'main__calc-calendar-status-paid' },
        'false': { text: 'Не оплачен', cls: 'main__calc-calendar-status-notpaid' },
    };

    const calcDetailHeader = calcDetail
        ? `Счёт ${calcDetail.invoice ? `№${calcDetail.invoice}` : formatDateString(calcDetail.createdAt)} — ${calcDetail.company?.name ?? ''}`
        : '';

    const calcDetailBody = calcDetail ? (
        <>
            <table className='calcPopup__table'>
                <tbody className='calcPopup__tbody'>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Предприятие:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>
                            {calcDetail.company
                                ? <Link to={URLS.COMPANY_URL.replace(':id', `${calcDetail.companyId}`)}
                                        onClick={() => setIsCalcDetailOpen(false)}>{calcDetail.company.name}</Link>
                                : '-'}
                        </td>
                        <td className='calcPopup__td calcPopup__td-static'>Статус:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>
                            {CALC_STATUS_LABEL[`${calcDetail.status}`]?.text ?? '-'}
                        </td>
                    </tr>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Счёт-фактура:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{calcDetail.invoice ? `№${calcDetail.invoice}` : '-'}</td>
                        <td className='calcPopup__td calcPopup__td-static'>Получатель платежа:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{calcDetail.payee ? calcDetail.payee.name : '-'}</td>
                    </tr>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Создал:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{calcDetail.createdBy ? calcDetail.createdBy.username : '-'}</td>
                        <td className='calcPopup__td calcPopup__td-static'>Дата создания:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{formatDateString(calcDetail.createdAt)}</td>
                    </tr>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Закрыл:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{calcDetail.closedBy ? calcDetail.closedBy.username : '-'}</td>
                        <td className='calcPopup__td calcPopup__td-static'>Дата закрытия:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic'>{calcDetail.closedAt ? formatDateString(calcDetail.closedAt) : '-'}</td>
                    </tr>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Рахунок-фактура:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic' colSpan={3}>
                            {calcDetail.pdfFile ?
                                <a href={`${REACT_APP_API_URL}media/${calcDetail.pdfFile}`} target='_blank' rel='noreferrer'
                                   onClick={() => {
                                       const cookieJwt = localStorage.getItem('token');
                                       if (cookieJwt) setCookie('cookieJwt', cookieJwt, 7);
                                   }}>{calcDetail.pdfFile}</a>
                                : '-'}
                        </td>
                    </tr>
                    <tr className='calcPopup__tr'>
                        <td className='calcPopup__td calcPopup__td-static'>Видаткова накладна:</td>
                        <td className='calcPopup__td calcPopup__td-dynamic' colSpan={3}>
                            {calcDetailNotePdf ?
                                <a href={`${REACT_APP_API_URL}media/${calcDetailNotePdf}`} target='_blank' rel='noreferrer'
                                   onClick={() => {
                                       const cookieJwt = localStorage.getItem('token');
                                       if (cookieJwt) setCookie('cookieJwt', cookieJwt, 7);
                                   }}>{calcDetailNotePdf}</a>
                                : '-'}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className='calcPopup__calculation-container'>
                <CalculationTable isEditable={false} Key='MainCalcDetail'
                                   tableData={calcDetail.calculation?.tableData}
                                   calcConfig={calcDetailConfig}/>
            </div>
            <div id='MainCalcDetail-footer' className='main__calc-detail-footer'></div>
        </>
    ) : <></>;

    return (
        <div className='main page-content-container'>
            <NavPanel/>
            <Popup isActive={isCalcDetailOpen} setIsActive={setIsCalcDetailOpen}
                   headerName={calcDetailHeader} bodyDivElement={calcDetailBody}/>
            <div className='main__body page_content_body'>
                <div className="main__task-deal-history-container">
                  <div className="main__top-row-container">
                    <div className="main__task-container main__data-container contentWindow">
                        <div className="main__data-header contentWindow__header"><span className='contentWindow__name'>Задачи</span></div>
                        <nav className="main__data-nav contentWindow__nav tab-group">
                            <button className={`tab ${taskOption === 'taskAll' ? 'is-active' : ''}`}
                                    onClick={() => { setTaskOption('taskAll') }}
                            >Все задачи({ allTasks ? allTasks.length : 0 })</button>
                            <button className={`tab ${taskOption === 'taskMine' ? 'is-active' : ''}`}
                                    onClick={() => { setTaskOption('taskMine') }}
                            >Мои задачи({ myTasks ? myTasks.length : 0 })</button>
                            {
                                perms.has('tasks.add') ?
                                    <button className={`tab ${taskOption === 'taskNew' ? 'is-active' : ''}`}
                                            onClick={() => { setTaskOption('taskNew') }}
                                    >Новая задача</button>
                                    :
                                    null
                            }
                        </nav>
                        { taskBodyJSX }
                    </div>

                    <div className="main__deal-container main__data-container contentWindow">
                        <div className="main__data-header contentWindow__header main__calc-header">
                            <span className='contentWindow__name'>Активные счета ({visibleCalculations.length})</span>
                            <form className='main__calc-search' onSubmit={handleCalcSearch}>
                                <select className='select main__calc-search-payee'
                                        value={calcSearchPayee}
                                        onChange={(e) => setCalcSearchPayee(e.target.value)}
                                        title='Получатель платежа искомого счёта'>
                                    {
                                        payees.map((p) =>
                                            <option key={`calcSearchPayee-${p.id}`} value={`${p.id}`}>{p.name}</option>
                                        )
                                    }
                                </select>
                                <input className='input main__calc-search-input'
                                       type='number'
                                       min='0'
                                       placeholder='№ счёта'
                                       value={calcSearchInvoice}
                                       onChange={(e) => setCalcSearchInvoice(e.target.value)}/>
                                <button type='submit'
                                        className='nav__button btn-primary main__calc-search-btn'
                                        disabled={calcSearching || calcSearchInvoice.trim() === ''}>
                                    {calcSearching ? '…' : 'Найти'}
                                </button>
                            </form>
                        </div>
                        <div className="main__calc-filters">
                            <select className={'select main__calc-filters-select'}
                                    value={calcCuratorFilter}
                                    onChange={(e) => setCalcCuratorFilter(e.target.value)}>
                                <option value={'all'}>Все пользователи</option>
                                {
                                    Object.keys(users).map((id) =>
                                        <option key={`calcCuratorOpt-${id}`} value={id}>{users[Number(id)]}</option>
                                    )
                                }
                            </select>
                            <button type='button'
                                    className={`nav__button btn-ghost main__calc-calendar-toggle ${isCalcCalendarOpen ? 'is-active' : ''}`}
                                    onClick={openCalcCalendar}
                                    title='Календарь закрытых счетов выбранного пользователя'>
                                📅 {isCalcCalendarOpen ? 'Список счетов' : 'Календарь'}
                            </button>
                        </div>
                        <div className="main__data-body contentWindow__body main__calc-data-body">
                            {isCalcCalendarOpen ? (
                                <div className='main__calc-calendar'>
                                    <div className='main__calc-calendar-nav'>
                                        <button type='button' className='main__calc-calendar-nav-btn'
                                                onClick={() => shiftCalendarMonth(-1)}>‹</button>
                                        <span className='main__calc-calendar-month'>
                                            {MONTH_NAMES[calendarMonth.getMonth()]} {calendarMonth.getFullYear()}
                                        </span>
                                        <button type='button' className='main__calc-calendar-nav-btn'
                                                onClick={() => shiftCalendarMonth(1)}>›</button>
                                    </div>
                                    <div className='main__calc-calendar-weekdays'>
                                        {WEEKDAY_NAMES.map((w) => <span key={w}>{w}</span>)}
                                    </div>
                                    <div className='main__calc-calendar-grid'>
                                        {calendarGrid.map((date, idx) => {
                                            if (!date) return <span key={idx} className='main__calc-calendar-day main__calc-calendar-day-empty'/>;
                                            const key = dateKey(date.toISOString());
                                            const count = (closedByDateKey[key] || []).length;
                                            return (
                                                <button type='button' key={idx}
                                                        className={
                                                            'main__calc-calendar-day' +
                                                            (key === todayKey ? ' main__calc-calendar-day-today' : '') +
                                                            (key === selectedCalendarDateKey ? ' main__calc-calendar-day-selected' : '')
                                                        }
                                                        onClick={() => setSelectedCalendarDateKey(key)}>
                                                    <span className='main__calc-calendar-day-num'>{date.getDate()}</span>
                                                    {count > 0 && <span className='main__calc-calendar-day-badge'>{count}</span>}
                                                </button>
                                            );
                                        })}
                                    </div>

                                    {selectedCalendarDateKey && (
                                        <div className='main__calc-calendar-details'>
                                            <div className='main__calc-calendar-details-header'>
                                                <span>Закрытые счета за {selectedCalendarDateKey.split('-').reverse().join('.')}</span>
                                                <button type='button' className='main__calc-calendar-details-close'
                                                        onClick={() => setSelectedCalendarDateKey(null)}>×</button>
                                            </div>
                                            {selectedDateCalcs.length === 0 ? (
                                                <p className='main__calc-calendar-empty'>Нет закрытых счетов за эту дату</p>
                                            ) : (
                                                <table className='main__calc-calendar-details-table'>
                                                    <thead>
                                                        <tr>
                                                            <td></td>
                                                            <td>Предприятие</td>
                                                            <td>Статус</td>
                                                            <td>Счёт-фактура</td>
                                                            <td>Получатель платежа</td>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedDateCalcs.map((c) => {
                                                            const statusInfo = CALC_STATUS_LABEL[`${c.status}`];
                                                            return (
                                                                <tr key={`calcCal-${c.id}`}
                                                                    id={`calcCalRow-${c.id}`}
                                                                    className={
                                                                        'main__calc-calendar-details-row' +
                                                                        (c.id === flashCalcId ? ' main__calc-calendar-details-row-found' : '') +
                                                                        (c.id === highlightCalcId ? ' main__calc-calendar-details-row-selected' : '')
                                                                    }
                                                                    onAnimationEnd={() => {
                                                                        if (c.id === flashCalcId) setFlashCalcId(null);
                                                                    }}>
                                                                    <td className='main__calc-calendar-details-btn-cell'>
                                                                        <button type='button' className='main__calc-calendar-details-btn'
                                                                                title='Предпросмотр счёта'
                                                                                onClick={() => openCalcDetail(c.id)}>
                                                                            <svg width='16' height='16' viewBox='0 0 24 24' fill='none'
                                                                                 stroke='currentColor' strokeWidth='2'
                                                                                 strokeLinecap='round' strokeLinejoin='round'>
                                                                                <path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z'/>
                                                                                <circle cx='12' cy='12' r='3'/>
                                                                            </svg>
                                                                        </button>
                                                                    </td>
                                                                    <td>{c.company ? c.company.name : '—'}</td>
                                                                    <td className={statusInfo?.cls}>{statusInfo?.text ?? '-'}</td>
                                                                    <td className={c.id === highlightCalcId ? 'main__calc-calendar-details-invoice-found' : undefined}>
                                                                        {c.invoice ? `№${c.invoice}` : '-'}
                                                                    </td>
                                                                    <td>{c.payee ? c.payee.name : '-'}</td>
                                                                    <td className='main__calc-calendar-details-btn-cell'>
                                                                        {c.company && (
                                                                            <a className='main__calc-calendar-details-btn'
                                                                               href={URLS.COMPANY_URL.replace(':id', `${c.companyId}`)}
                                                                               target='_blank' rel='noreferrer'
                                                                               title='Открыть предприятие в новом окне'>↗</a>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                            <table className='main__calc-table'>
                                <thead className='main__calc-thead'>
                                {
                                    user.getPermissions.has('calculation.update') ?
                                        <tr>
                                            <td className='main__calc-thead-td-1'>Предприятие</td>
                                            <td className='main__calc-thead-td-2'>Дата создания</td>
                                            <td className='main__calc-thead-td-3'>Счёт-фактура</td>
                                            <td className='main__calc-thead-td-4'>Куратор</td>
                                            <td className='main__calc-thead-td-5' colSpan={2}></td>
                                        </tr>
                                        :
                                        <tr>
                                            <td className='main__calc-thead-td-1'>Предприятие</td>
                                            <td className='main__calc-thead-td-2'>Дата создания</td>
                                            <td className='main__calc-thead-td-3'>Счёт-фактура</td>
                                            <td className='main__calc-thead-td-4'>Куратор</td>
                                        </tr>
                                }
                                </thead>
                                <tbody className='main__calc-tbody'>
                                {
                                    visibleCalculations.length === 0 ?
                                        <tr>
                                            {
                                                user.getPermissions.has('calculation.update') ?
                                                    <td colSpan={6}>Активных счетов нет</td>
                                                    :
                                                    <td colSpan={4}>Активных счетов нет</td>
                                            }

                                        </tr>
                                        :
                                        visibleCalculations.map((ac) =>
                                                <tr key={`calc-${ac.id}`}
                                                    className={fadingCalcIds.has(ac.id) ? 'main__calc-tr-fading' : ''}>
                                                    <td>
                                                        <Link to={URLS.COMPANY_URL.replace(':id', `${ac.companyId}`)}>{ac.company.name}</Link>
                                                    </td>
                                                    <td>{formatDateString(`${ac.createdAt}`)}</td>
                                                    <td>{ac.invoice ? `№${ac.invoice}` : '-'}</td>
                                                    <td>{ac.company.curatorId ? users[ac.company.curatorId] : '-'}</td>
                                                    {
                                                        user.getPermissions.has('calculation.update') ?
                                                            <td id={ `paidCalcTd-${ac.id}` }>
                                                                <button 
                                                                    id={`paidCalcBtn-${ac.id}`}
                                                                    className='main__calc-btn'
                                                                        onClick={() => {
                                                                            changeCalcStatus({
                                                                                calcId: ac.id,
                                                                                status: 'paid'
                                                                            })
                                                                            replaceCalcBtnWithLoading({ elId: ac.id, action: 'hide' })
                                                                            startCalcFadeOut(ac)
                                                                        }}
                                                                ><img src={paidIco} alt="+"/>
                                                                
                                                                </button>
                                                            </td>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        user.getPermissions.has('calculation.update') ?
                                                        <td id={ `notPaidCalcTd-${ac.id}` }>
                                                                <button 
                                                                    id={`notPaidCalcBtn-${ac.id}`}
                                                                    className='main__calc-btn'
                                                                        onClick={() => {
                                                                            changeCalcStatus({
                                                                                calcId: ac.id,
                                                                                status: 'notPaid'
                                                                            })
                                                                            replaceCalcBtnWithLoading({ elId: ac.id, action: 'hide' })
                                                                            startCalcFadeOut(ac)
                                                                        }}
                                                                ><img src={notPaidIco} alt="-"/>
                                                                
                                                                </button>
                                                                
                                                            </td>
                                                            :
                                                            null
                                                    }
                                                </tr>
                                        )
                                }
                                </tbody>
                            </table>
                            )}
                        </div>
                    </div>
                  </div>

                  <HistoryContainer historyType={'actionHistory'} containerName={'main'}/>

                </div>
            </div>
        </div>
    );
});


export default Main;
